// console-log.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConsoleLogService {
  private logStore: { type: string; message: any[] }[] = [];

  constructor() {
    this.hookConsole();
  }

  private hookConsole() {
    const originalLog = console.log;
    const originalError = console.error;
    const originalWarn = console.warn;

    console.log = (...args) => {
      this.logStore.push({ type: 'log', message: args });
      originalLog.apply(console, args);
    };

    console.error = (...args) => {
      this.logStore.push({ type: 'error', message: args });
      originalError.apply(console, args);
    };

    console.warn = (...args) => {
      this.logStore.push({ type: 'warn', message: args });
      originalWarn.apply(console, args);
    };
  }

  getLogs(type: 'warn' | 'error' | 'log' | 'all' = 'all') {
    return this.logStore.filter((log) => log.type === type || type === 'all');
  }

  clearLogs() {
    this.logStore = [];
  }
}
